/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isBrowser as e}from"../is-browser.js";import{hasReducedMotionListener as r,prefersReducedMotion as t}from"./state.js";function i(){if(r.current=!0,e)if(window.matchMedia){const e=window.matchMedia("(prefers-reduced-motion)"),r=()=>t.current=e.matches;e.addListener(r),r()}else t.current=!1}export{i as initPrefersReducedMotion};
//# sourceMappingURL=index.js.map
